import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';
import EFDelta2SloganCn from '@/components/UI/svg/Delta2/Icon/EFDelta2SloganCn';
import EFDelta2SloganDe from '@/components/UI/svg/Delta2/Icon/EFDelta2SloganDe';
import EFDelta2SloganEs from '@/components/UI/svg/Delta2/Icon/EFDelta2SloganEs';
import EFDelta2SloganFr from '@/components/UI/svg/Delta2/Icon/EFDelta2SloganFr';
import EFDelta2SloganIt from '@/components/UI/svg/Delta2/Icon/EFDelta2SloganIt';
import EFDelta2SloganJp from '@/components/UI/svg/Delta2/Icon/EFDelta2SloganJp';
import EFDelta2SloganKr from '@/components/UI/svg/Delta2/Icon/EFDelta2SloganKr';
import EFDelta2SloganMEAR from '@/components/UI/svg/Delta2/Icon/EFDelta2SloganMEAR';
import EFDelta2SloganRu from '@/components/UI/svg/Delta2/Icon/EFDelta2SloganRu';
import EFDelta2SloganUs from '@/components/UI/svg/Delta2/Icon/EFDelta2SloganUs';
import EFDelta2VideoPlayer from '@/components/UI/svg/Delta2/Icon/EFDelta2VideoPlayer';
import { useGlobal } from '@/utils/useGlobal';
import { TimelineMax, TweenMax } from 'gsap';
import css from './index.module.scss';
export default function Comp() {
    const { useEffect, useState, useLang, useRouter, gtm } = useGlobal();
    const [isEnterA, setIsEnterA] = useState(false);
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);
    const { locale } = useRouter();
    const { t } = useLang('delta2portablepowerstation');

    const sloganComp: any = {
        de: <EFDelta2SloganDe id="sloganId" />,
        es: <EFDelta2SloganEs id="sloganId" />,
        fr: <EFDelta2SloganFr id="sloganId" />,
        it: <EFDelta2SloganIt id="sloganId" />,
        jp: <EFDelta2SloganJp id="sloganId" />,
        cn: <EFDelta2SloganCn id="sloganId" />,
        kr: <EFDelta2SloganKr id="sloganId" />,
        cis: <EFDelta2SloganRu id="sloganId" />,
        tw: <EFDelta2SloganCn id="sloganId" />,
        sa: <EFDelta2SloganMEAR id="sloganId" />,
    };

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/_YQbsiPE8to',
        cn: {
            SD: 'https://videos.ecoflow.com/72a93ed2912944e394c00c987ec02d51/eca86cd8599740649e24537d42a8e4f2-1fea741c33cd80836608e25bcdde5b24-fd.mp4',
            HD: 'https://videos.ecoflow.com/72a93ed2912944e394c00c987ec02d51/eca86cd8599740649e24537d42a8e4f2-530f22b100209d9680edc68de768d511-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/4827a210-1831b1bcf81-0004-9c91-e6d-40030.mp4',
        },
        kr: 'https://www.youtube.com/embed/j2M-lCE7GlM',
        cis: 'https://www.youtube.com/embed/kvOQkL1kx7M',
    };

    useEffect(() => {
        setIsEnterA(true);
    }, []);

    // 动画--放大字体
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationA',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '50%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.animationA .msg-box',
            0.4,
            {
                width: '2560px',
                height: '1440px',
                ease: 'linear',
            },
            {
                width: '51200px',
                height: '28800px',
                ease: 'linear',
            },
        );

        const tweenA2 = TweenMax.fromTo(
            '.animationA .msg-box',
            0.1,
            {
                opacity: 1,
                ease: 'linear',
            },
            {
                opacity: 0,
                ease: 'linear',
            },
        );

        const tweenA3 = TweenMax.fromTo(
            '.animationA .msg-box2',
            0.3,
            {
                opacity: 0,
                ease: 'linear',
            },
            {
                opacity: 1,
                ease: 'linear',
            },
        );
        const timelineA1 = new TimelineMax();
        timelineA1.add(tweenA1).add(tweenA2, 0.3).add(tweenA3, 0.4);
        sceneA1.setTween(timelineA1);

        controllerDelta2?.addScene(sceneA1);
    }, []);

    const playerVideo = (position: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA 2 - Not Just a Battery',
            position,
            __btn_id1: css.animationA,
            __btn_id2: t('delta2.aniA_video_btn'),
        });
        setShowEFVideoModal(true);
    };

    return (
        <div className={`${css.animationA} animationA GtmModuleData-section`} data-section-id={css.animationA} data-section-title={t('delta2.aniA_msg_desc')}>
            <div className={`sticky-box ${isEnterA ? 'isEnterA' : ''}`}>
                <div className="video-box">
                    <EFVideo className="video" sources={['/media/delta2/pc/animA.webm', '/media/delta2/pc/animA.mp4']} />
                </div>
                <div className="msg-box">{sloganComp[locale] || <EFDelta2SloganUs id="sloganId" />}</div>
                <div className="msg-box2">
                    <div className="msg-desc">{t('delta2.aniA_msg_desc')}</div>
                    <div className="watch-video-btn GtmModuleData-btn-text" onClick={() => playerVideo('EcoFlow DELTA2 Slogan')}>
                        <span>{t('delta2.aniA_video_btn')}</span>
                        <div className="btn">
                            <EFDelta2VideoPlayer />
                        </div>
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
